import * as bootstrap from "bootstrap";

// Bootstrap
window.$ = window.jQuery = require('jquery');

// Note: If you want to make bootstrap globally available, e.g. for using `bootstrap.modal`
window.bootstrap = bootstrap;
